var AlligatorView, CardUI, CardUIRenderer;

CardUI = require('../../../../node_modules/grpn-card-ui/lib/frontend');

CardUIRenderer = require('../../../../node_modules/grpn-card-ui/render');

AlligatorView = {
  hideWidgets: function() {
    return $('.cross-sell-widgets').hide();
  },
  showWidgets: function(page_type) {
    var $crossSellWidgetContainer, $crossSellWidgetContentContainer, cardHtml;
    if (this.isWidgetLayoutEnabled()) {
      $crossSellWidgetContainer = $('.cross-sell-widgets');
      $crossSellWidgetContentContainer = $('#cross-sell-widgets-content-container');
      $crossSellWidgetContentContainer.empty();
      cardHtml = CardUIRenderer.renderCards(widgetResponse);
      $crossSellWidgetContentContainer.html(cardHtml);
      switch (page_type) {
        case 'ticket-success':
          $crossSellWidgetContentContainer.removeClass('problem-solved-step');
          $crossSellWidgetContentContainer.addClass('ticket-success-step');
          break;
        case 'problem-solved':
          $crossSellWidgetContentContainer.removeClass('ticket-success-step');
          $crossSellWidgetContentContainer.addClass('problem-solved-step');
      }
      $crossSellWidgetContainer.show();
      CardUI.init();
      return $('.lazy-load').lazyload({});
    }
  },
  isWidgetLayoutEnabled: function() {
    return typeof widgetResponse !== "undefined" && widgetResponse !== null;
  }
};

module.exports = AlligatorView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9hbGxpZ2F0b3Jfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL3ZpZXdzL2FsbGlnYXRvcl92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQUEsR0FBUyxPQUFBLENBQVEsb0RBQVI7O0FBQ1QsY0FBQSxHQUFpQixPQUFBLENBQVEsOENBQVI7O0FBRWpCLGFBQUEsR0FFRTtFQUFBLFdBQUEsRUFBYSxTQUFBO1dBQ1gsQ0FBQSxDQUFFLHFCQUFGLENBQXdCLENBQUMsSUFBekIsQ0FBQTtFQURXLENBQWI7RUFHQSxXQUFBLEVBQWEsU0FBQyxTQUFEO0FBQ1gsUUFBQTtJQUFBLElBQUcsSUFBQyxDQUFBLHFCQUFELENBQUEsQ0FBSDtNQUNFLHlCQUFBLEdBQTZCLENBQUEsQ0FBRSxxQkFBRjtNQUM3QixnQ0FBQSxHQUFtQyxDQUFBLENBQUUsdUNBQUY7TUFDbkMsZ0NBQWdDLENBQUMsS0FBakMsQ0FBQTtNQUNBLFFBQUEsR0FBVyxjQUFjLENBQUMsV0FBZixDQUEyQixjQUEzQjtNQUNYLGdDQUFnQyxDQUFDLElBQWpDLENBQXNDLFFBQXRDO0FBQ0EsY0FBTyxTQUFQO0FBQUEsYUFDTyxnQkFEUDtVQUVJLGdDQUFnQyxDQUFDLFdBQWpDLENBQTZDLHFCQUE3QztVQUNBLGdDQUFnQyxDQUFDLFFBQWpDLENBQTBDLHFCQUExQztBQUZHO0FBRFAsYUFJTyxnQkFKUDtVQUtJLGdDQUFnQyxDQUFDLFdBQWpDLENBQTZDLHFCQUE3QztVQUNBLGdDQUFnQyxDQUFDLFFBQWpDLENBQTBDLHFCQUExQztBQU5KO01BT0EseUJBQXlCLENBQUMsSUFBMUIsQ0FBQTtNQUNBLE1BQU0sQ0FBQyxJQUFQLENBQUE7YUFDQSxDQUFBLENBQUUsWUFBRixDQUFlLENBQUMsUUFBaEIsQ0FBeUIsRUFBekIsRUFmRjs7RUFEVyxDQUhiO0VBcUJBLHFCQUFBLEVBQXVCLFNBQUE7V0FDcEI7RUFEb0IsQ0FyQnZCOzs7QUF3QkYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
